import fontkit from "@pdf-lib/fontkit";
import JsBarcode from "jsbarcode";
import { PDFDocument, rgb } from "pdf-lib";
import React, { useImperativeHandle } from "react";

const BarcodePDFGenerator = React.forwardRef((props, ref) => {
  const convertToBase64 = uint8Array => {
    let binary = "";
    const bytes = new Uint8Array(uint8Array);
    const len = bytes.byteLength;

    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return btoa(binary);
  };

  const generatePDFBase64 = async ({ barcodeValue, subLabel, hubReceive }) => {
    console.log("🚀 ~ generatePDF Barcode Base64", {
      subLabel,
      barcodeValue,
      hubReceive,
    });
    const pdfDoc = await PDFDocument.create();
    pdfDoc.registerFontkit(fontkit);
    const page = pdfDoc.addPage();

    const cmToPoints = cm => (cm * 72) / 2.54;

    const customWidthCm = 5;
    const customHeightCm = 3;

    const customWidth = cmToPoints(customWidthCm);
    const customHeight = cmToPoints(customHeightCm);

    page.setSize(customWidth, customHeight);
    // page.setRotation(degrees(90));
    // Get the dimensions of the A4 page
    const pageWidth = page.getWidth();
    const pageHeight = page.getHeight();

    const response = await fetch("/fonts/OpenSans-Bold.ttf");
    const fontArrayBuffer = await response.arrayBuffer();
    const cutomFont = await pdfDoc.embedFont(fontArrayBuffer);
    page.setFont(cutomFont);

    const fontSize = 10;

    // START label content

    const contentHeight = cutomFont.heightAtSize(fontSize);
    const contentText = subLabel || "";
    let yContent = 6;
    if (contentText) {
      // const barcodeValueUtf8 = unescape(encodeURIComponent(contentText));
      const contentWidth = cutomFont.widthOfTextAtSize(contentText, fontSize);

      const xContent = (pageWidth - contentWidth) / 2;
      page.drawText(contentText, {
        x: xContent,
        y: yContent,
        size: fontSize,
        color: rgb(0, 0, 0),
      });
    }

    // START hubReceive content

    const hubReceiveText = hubReceive || "";
    let yhubReceive = 7;
    if (hubReceiveText) {
      // const barcodeValueUtf8 = unescape(encodeURIComponent(hubReceiveText));
      const hubReceiveWidth = cutomFont.widthOfTextAtSize(
        hubReceiveText,
        fontSize
      );

      const xhubReceive = (pageWidth - hubReceiveWidth) / 2;
      page.drawText(hubReceiveText, {
        x: xhubReceive,
        y: yhubReceive,
        size: fontSize,
        color: rgb(0, 0, 0),
      });
    }

    // END label content

    // START label code
    const text = barcodeValue;
    const textWidth = cutomFont.widthOfTextAtSize(text, fontSize);

    const xText = (pageWidth - textWidth) / 2;
    const yText = contentHeight + 5;
    page.drawText(barcodeValue, {
      x: xText,
      y: contentHeight + 5,
      size: fontSize,
      color: rgb(0, 0, 0),
    });

    // END label code

    // START BARCODE
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, barcodeValue, {
      format: "CODE128",
      displayValue: false,
    });

    const barcodeBytes = barcodeCanvas.toDataURL("image/jpeg").split(",")[1];
    const barcodeBuffer = new Uint8Array(
      atob(barcodeBytes)
        .split("")
        .map(char => char.charCodeAt(0))
    );

    const barcodeImage = await pdfDoc.embedJpg(barcodeBuffer);
    //
    const xCode = (pageWidth - cmToPoints(4)) / 2;
    //

    page.drawImage(barcodeImage, {
      x: xCode,
      y: yContent + yText + 2,
      width: cmToPoints(4),
      height: cmToPoints(2),
      // rotate: degrees(-90),
    });
    // END BARCODE

    const pdfBytes = await pdfDoc.save();

    const base64Data = await convertToBase64(pdfBytes);

    // // Create a Blob from the PDF data and generate a download link
    // const blob = new Blob([pdfBytes], { type: "application/pdf" });
    // const url = URL.createObjectURL(blob);
    // const link = document.createElement("a");
    // link.href = url;
    // link.download = "barcode.pdf";
    // link.click();

    // // Cleanup
    // URL.revokeObjectURL(url);

    return base64Data;
  };

  useImperativeHandle(ref, () => ({
    generatePDFBase64({ barcodeValue, subLabel, hubReceive }) {
      return generatePDFBase64({ barcodeValue, subLabel, hubReceive });
    },
  }));

  return (
    <>
      {/* <button
        onClick={() => {
          generatePDF({ barcodeValue: "code", subLabel: "label" });
        }}
      >
        Generate PDF
      </button> */}
    </>
  );
});

BarcodePDFGenerator.propTypes = {
  // donutLabel: PropTypes.array,
};

BarcodePDFGenerator.defaultProps = {
  // donutLabel: [],
};

export default BarcodePDFGenerator;
